<template>
    <div 
      class="  px-10 mt-12">
      <v-dialog v-model="dialog.pembayaran"
        @keydown.esc="dialog.pembayaran = false"
        :fullscreen="dialog.fullscreen"
        width="700"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
          class="pa-8 pt-6">
          <v-card-title 
            class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
            
            Pembayaran
  
            <v-spacer/>
  
            <!-- <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#4828a1">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>
  
            <v-icon 
              @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon> -->
  
            <v-icon 
              @click="dialog.pembayaran = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
              class="cursor-pointer"
              size="18"
              color="#000000">
              mdi-close
            </v-icon>
          </v-card-title>
          
          <!-- <v-divider 
            class="mb-2"
            style="border-top: 2px dashed #e0e0e0;"/> -->
  
          <v-card-text 
            class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
            <ValidationObserver 
              ref="form">
              <v-form>
  
                <ValidationProvider
                  name="Metode Pembayaran" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input">
                    Metode Pembayaran
                  </div>
  
                  <v-autocomplete
                    v-on:keydown.enter.prevent="save()"
                                
                    filled
                    rounded
                    dense
                    solo
  
                    color="#4828a1"
                    placeholder="Metode Pembayaran"
                    v-model="form.payment_method"
                    :items="['Tunai','Transfer']"
                    
                    outlined
                    class="mt-4"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                  </v-autocomplete>
                </ValidationProvider>
  
                <!-- <v-autocomplete
                  v-model="form.payment_method"
                  :items="['Tunai','Transfer']"
                  
                  label="Pilih Tipe Pembayaran"
                  
                  dense
                  outlined
                  hide-details
                  style="width: 100%"
                  class="mt-4"
                  >
                </v-autocomplete> -->
  
                <div v-if="form.payment_method === 'Transfer'">
                  <div 
                  class="fs-15 label-input">
                  Ditrasfer Ke
                </div>


                <ValidationProvider
                  name="Nama Bank" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input">
                    <!-- <span class="red--text">*</span> -->
                    Nama Bank Supplier
                  </div>

                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    
                    filled
                    rounded
                    dense
                    solo

                    color="#4828a1"
                    placeholder="Nama Bank"

                    

                    v-model="form.payment_bank_name"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                  </v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  name="No Rekening" 
                  rules="required" 
                  v-slot="{ errors }">
                  <div 
                    class="fs-15 label-input">
                    <!-- <span class="red--text">*</span> -->
                    No Rekening Supplier
                  </div>

                  <v-text-field
                    v-on:keydown.enter.prevent="save()"
                    
                    filled
                    rounded
                    dense
                    solo
                    type="number"

                    color="#4828a1"
                    placeholder="No Rekening"

                    

                    v-model="form.payment_rek_number"
                    :error-messages="errors"
                    required
                    style="border-radius: 10px;">
                  </v-text-field>
                </ValidationProvider>
                  <!-- <ValidationProvider
                    name="Pilih Bank" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div 
                      class="fs-15 label-input">
                      Pilih Bank
                    </div>
  
                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                                  
                      filled
                      rounded
                      dense
                      solo
  
                      color="#4828a1"
                      item-text="name"
                      item-value="name"
                      placeholder="Pilih Bank"
                      v-model="form.bank"
                      :items="bank"
                      
                      outlined
                      return-object
                      class="mt-4"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:selection="{ item }">
                        <div
                          v-if="item" style="color: #4828a1">
                          {{ item.name }} ({{ item.rek_number }})
                        </div>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.rek_number }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider> -->
                </div>
                <div class="mt-3">
                  <div 
                    class="fs-15 label-input">
                    <!-- <span class="red--text">*</span> -->
                    Bukti Pembayaran
                  </div>
                  <uploadfolder
                    v-model="upload.payment_bukti_url" 
                    style="height: 250px; width: 250px">
                    <div 
                      slot="activator"
                      class="cursor-pointer">
                      <v-card 
                        flat
                        height="250"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <div v-if="form.payment_bukti_url.length < 1">
                          <v-icon v-if="!process.payment_bukti_url"
                            size="60" 
                            color="#4828a1">
                            mdi-cloud-upload-outline
                          </v-icon>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>

                        <v-img v-else
                          contain
                          height="250"
                          :src="form.payment_bukti_url" 
                          :alt="form.payment_bukti_url"
                          class="text-center d-flex align-center">
                          <div 
                            class="d-flex aling-center justify-center" 
                            style="width: 100%; height: auto;">
                            <v-icon v-if="!process.payment_bukti_url"
                              size="60" 
                              color="white">
                              mdi-cloud-upload-outline
                            </v-icon>

                            <v-progress-circular v-else
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </div>
                        </v-img>
                      </v-card>
                    </div>
                  </uploadfolder>
                </div>
              </v-form>
            </ValidationObserver>
  
  
            <div v-if="message.error.length > 0"
              class="text-left mt-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
  
  
          <!-- <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/> -->
  
          <v-card-actions
            class="pa-0 pt-4">
            <v-spacer/>
  
            <v-btn
              rounded
              @click="save()"
              :loading="process.form"
              :disabled="process.form"
              width="190"
              height="45"
              elevation="0"
              color="#6948c6"
              class="fs-16 white--text text-capitalize border-radius">
              Ya, {{ message.status }}
            </v-btn>
  
            <!-- <v-btn
              rounded
              width="120"
              @click="dialog.pembayaran = false; dialog.fullscreen = false; selected.status = [];"
              :disabled="process.status"
              outlined
              class="body-2 font-weight-bold text-capitalize red--text">
              Batal
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-layout wrap>
        <v-flex>
          <section>
            
            <div class="color-dark-blue fs-22 font-weight-bold mb-6">
              Detail Invoice Supplier
            </div>
  
            <v-row
              class="mt-3">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 25px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
  
                  <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="fs-18 input-label">
                        Informasi
                      </div>
                      <v-divider class="mt-4 mb-1"></v-divider>
                    <v-row>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Invoice
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.number }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Nama Supplier
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.supplier_name }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Permintaan
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.po_number }}
                          </div>
                        </div>
                      </v-col>
                      <!-- <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Order
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.orders_number }}
                          </div>
                        </div>
                      </v-col> -->
                      <v-col cols="12" md="6">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Status
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.status == 'belum lunas' ? 'Belum Lunas' : detail.status == 'lunas' ? 'Lunas' : detail.status == 'Set Order' ? 'Menunggu Pengirirman' : '-' }}
                          </div>
                        </div>
                      </v-col>
                      <!-- <v-col cols="12">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Catatan
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.note === '' ? '-' : detail.note }}
                          </div>
                        </div>
                      </v-col> -->
                    </v-row>
                  </v-card-text>
                </v-card>
  
                <div class="mt-5" v-if="Object.keys(detail_penerimaan).length > 0">
                  <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7">
                    <v-card-text>
                      <div class="fs-18 input-label">
                        Detail Produk
                      </div>
                      <v-divider class="mt-4 mb-1"></v-divider>
  
                      <!-- <v-row class="mb-5">
                      
                        <v-col
                          cols="12"
                          md="3" class="pt-0">

                            <div 
                              class="fs-15 label-input">
                              Pembelian
                            </div>
      
                            <div class="fs-17 font-weight-bold label-input">
                              {{ detail_penerimaan.po_number }}
                            </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3" class="pt-0">

                            <div 
                              class="fs-15 label-input">
                              Nomor Penerimaan
                            </div>
      
                            <div class="fs-17 font-weight-bold label-input">
                              {{ detail_penerimaan.number }}
                            </div>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3" class="pt-0">

                            <div 
                              class="fs-15 label-input">
                              Nomor Surat Jalan
                            </div>
      
                            <div class="fs-17 font-weight-bold label-input">
                              {{ detail_penerimaan.no_surat_jalan }}
                            </div>
                        </v-col>
                        <v-col
                          cols="12"
                          md="3" class="pt-0">

                          <div class="fs-15 label-input">
                          
                            Tanggal Input
                          </div>
            
                          <div class="fs-17 font-weight-bold label-input">
                            {{ detail_penerimaan.date | date }}
                          </div>
                        </v-col>
                      </v-row> -->
                      <v-row>
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            Supplier :
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0">
                          <div>
                            <div class="fs-15 font-weight-bold">
                              {{ detail.supplier_name }}
                            </div>
                            <div>
                              {{ detail.supplier_address }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                          <div>
                            <table style="width: 100%;">
                              <tr>
                                <td class="font-weight-bold">
                                  Nomer Pembelian
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail_penerimaan.po_number }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Nomor Penerimaan
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail_penerimaan.number }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Nomor Surat Jalan
                                </td>
                                <td style="width: 80px" class="text-center">
                                  : 
                                </td>
                                <td class="text-right">
                                  {{ detail_penerimaan.no_surat_jalan }}
                                </td>
                              </tr>
                              <tr>
                                <td class="font-weight-bold">
                                  Tanggal Input
                                </td>
                                <td style="width: 80px" class="text-center">
                                  :
                                </td>
                                <td class="text-right">
                                  {{ detail.input_datetime | datetime }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </v-col>
                        <v-col cols="12" class="my-8">
                          <div style="overflow: auto; ">
                            <table style="width: 100%;">
                              <tr>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Kode Barang
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Nama Barang
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Quantity
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Harga Per Unit
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Ppn
                                </td>
                                <!-- <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Harga Bruto
                                </td>
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Disc. 
                                </td> -->
                                <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                  Harga Net. 
                                </td>
                              </tr>
                              <tr v-for="(item, index) in form.varian_arr" :key="index">
                                <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                  {{ item.penerimaan_detail_varian_sku }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                  {{ item.penerimaan_detail_varian_name }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                  <!-- {{ `${item.qty_dus_diterima}.${item.qty_lusin_diterima}.${item.qty_pcs_diterima}` }} -->
                                0.0.{{  item.penerimaan_detail_qty }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  {{ item.penerimaan_detail_harga_beli | price }} 
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  {{ item.penerimaan_detail_ppn_beli }}%
                                </td>
                                <!-- <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                                </td>
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  Rp. 0
                                </td> -->
                                <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                  <!-- {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }} -->
                                  {{ item.sub_total | price }} 
                                </td>
                              </tr>
                            </table>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <!-- <div>
                            Total Qty: <span>{{ `${detail.total_qty_dus}.${detail.total_qty_lusin}.${detail.total_qty_pcs}` }}</span>, Total Item: {{ detail.detail.length }}
                          </div> -->
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                          <div class="fs-15">
                            <table style="width: 100%;">
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Harga Bruto
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  : 
                                </td>
                                <td class="pa-2 text-right">
                                  <!-- {{ detail.sub_total*1 | price }} -->
                                  {{ total_nominal*1 | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Harga Pengiriman
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  : 
                                </td>
                                <td class="pa-2 text-right">
                                  {{ detail_penerimaan.harga_pengiriman*1 | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Harga Lainnya
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  : 
                                </td>
                                <td class="pa-2 text-right">
                                  {{ detail_penerimaan.harga_lain*1 | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Disc 
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  :
                                </td>
                                <td class="pa-2 text-right">
                                  -{{ detail_penerimaan.harga_disc*1 | price }}
                                </td>
                              </tr>
                              <!-- <tr>
                                <td class="pa-2 font-weight-bold">
                                  PPN 11%
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  : 
                                </td>
                                <td class="pa-2 text-right">
                                  {{ detail.sales_name }}
                                </td>
                              </tr> -->
                              <tr>
                                <td class="pa-2 font-weight-bold">
                                  Harga Net
                                </td>
                                <td style="width: 80px" class="pa-2 text-center">
                                  :
                                </td>
                                <td class="pa-2 text-right">
                                  <!-- {{ detail.total*1 | price }} -->
                                  {{ total_nominal*1+(detail_penerimaan.harga_lain*1)+(detail_penerimaan.harga_pengiriman*1)-(detail_penerimaan.harga_disc*1) | price }}
                                </td>
                              </tr>

                            </table>
                          </div>
                        </v-col>
                        <!-- <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Nomer Order
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.number }}
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Nama Sales
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.sales_name }}
                            </div>
                          </div>
                        </v-col>

                        <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Nama Customer
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.customer_name }}
                            </div>
                          </div>
                        </v-col>

                        <v-col>
                          <div>
                            <div class="mb-1 input-label">
                              Tanggal Order
                            </div>
                            <div class="fs-18 font-weight-bold">
                              {{ detail.input_datetime | date }}
                            </div>
                          </div>
                        </v-col> -->
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
  
                <v-card 
                  flat
                  class="mt-5"
                  style="border-radius: 25px; border: 1px solid #E7E7E7;"
                  v-if="Object.keys(detail).length > 0 && detail.status == 'lunas'">
  
                  <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="fs-18 input-label">
                      Detail Pembayaran
                    </div>
                    <v-divider class="mt-4 mb-1"></v-divider>
                    <v-row>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Metode Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_method }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Nama Bank
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_bank_name == '' ? '-' : detail.payment_bank_name}}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            No. Rekening
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.payment_rek_number == '' ? '-' : detail.payment_rek_number}}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Tanggal Pembayaran
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.paid_date | date }}
                          </div>
                        </div>
                      </v-col>

                    <v-col cols="3">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Dibayar Oleh
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.payment_user_name }}
                        </div>
                      </div>
                    </v-col>
                    <!-- <v-col cols="12">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Bukti Pembayaran
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          <v-img
                            :src="detail.payment_bukti_url"
                            style="width: 300px; height: 300px;"
                            contain
                            v-if="detail.payment_bukti_url !== ''"
                            class="d-flex align-center justify-center mt-2"
                            alt="Bukti Pembayaran">
                          </v-img>
                          <div v-if="detail.payment_bukti_url === ''">
                            -
                          </div>
                        </div>
                      </div>
                    </v-col> -->
                      <!-- <v-col cols="3">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Status
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.status == 'belum lunas' ? 'Belum Lunas' : detail.status == 'lunas' ? 'Lunas' : detail.status == 'Set Order' ? 'Menunggu Pengirirman' : '-' }}
                          </div>
                        </div>
                      </v-col> -->
                      <!-- <v-col cols="12">
                        <div>
                          <div class="fs-14" style="margin-bottom: 1px;">
                            Catatan
                          </div>
                          <div class="fs-16 label-input font-weight-bold">
                            {{ detail.note === '' ? '-' : detail.note }}
                          </div>
                        </div>
                      </v-col> -->
                    </v-row>
                  </v-card-text>
                </v-card>
  
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
  
                <!-- <v-btn 
                  @click="dialog.pembayaran = true; message.error = ''"
                  :loading="process.load"
                  :disabled="process.load"
                  v-if="detail.paid_date == ''"
                  width="150"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Pembayaran
                </v-btn> -->
                
                <v-btn
                  to="/finance/invoice-supplier"
                  color="red"
                  elevation="0"
                  width="140"
                  height="45"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                  style="font-weight: 600;">
                
                    Kembali
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          approved_by: [],
          approved_reason: '',
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,
  
          dialog: {
            status: false,
            pembayaran: false,
          },
  
          order_list: {},
          status: '',
  
          detail: {},
          detail_penerimaan: {},
  
          rejected_reason: '',
          bank: [],
  
          form: {
            id: '',
            bpb_arr: [],
            varian_arr: [],
            payment_method: 'Tunai',
            payment_bank_name: '',
            payment_rek_number: '',

            payment_bukti_url: '',
          },
          category: [],
          branch: [],
  
          mobilephone: {
            name: '',
            id: ''
          },
  
          upload: {
            payment_bukti_url: null,
            image_url: null
          },
          total_nominal: 0,
  
          process: {
            form: false,
  
            load: false,
  
            image_url: false,
            payment_bukti_url: false,
          },
          
          message: {
            success: '',
            error: '',
            status: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.payment_bukti_url': {
          handler: function () {
            if (this.upload.payment_bukti_url) {
              this.message.error = ''
              this.process.payment_bukti_url = this.upload.payment_bukti_url.process

              if (!this.process.payment_bukti_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.payment_bukti_url = this.upload.payment_bukti_url.fileuri

                // this.save_image()
              }
            }
          },
          deep: true
        },
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchDetail()
        this.fetchBank()
      },
      methods: {
        async fetchDetail () {
          this.process.load = true
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/invoice/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.form.bpb_arr = []
              this.detail = res.results.data
              this.fetchDetailOrder(this.detail.penerimaan_id)
              // res.results.data.bpb.map((item, index) => {
              //   this.form.bpb_arr.push({
              //     bpb_id: item.bpb_id,
              //     bpb_detail: item.detail
              //   })
              // })
  
              // this.form.bpb_arr.map((item, index) => {
              //   item.bpb_detail.map((items, indexs) => {
              //     items.bpb_detail_id = items.bpb_detail_id
              //     items.varian_name = items.varian_name
              //     items.varian_sku = items.varian_sku
              //     items.qty_pcs_diterima = items.qty_pcs_diterima
              //     items.qty_dus_diterima = items.qty_dus_diterima
              //     items.qty_lusin_diterima = items.qty_lusin_diterima
              //     items.qty_pcs_return = items.qty_pcs_return
              //     items.qty_dus_return = items.qty_dus_return
              //     items.qty_lusin_return = items.qty_lusin_return
              //   })
              // })
            }
            this.process.load = false
          })
        },
        async fetchBank () {
          // this.process.load = true
          let params = {
            limit: 10000000000000000000
          }
  
          await get('admin/bank/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.bank = res.results.data
            }
            // this.process.load = false
          })
        },
        async fetchDetailOrder (id) {
          this.process.load = true
          let params = {
            id: id
          }
  
          await get('admin/penerimaan/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.detail_penerimaan = res.results.data
              this.form.varian_arr=res.results.data.detail
              this.form.varian_arr.map((item, index) => {
              item.harga_include_ppn = item.penerimaan_detail_harga_beli*1 + (item.penerimaan_detail_harga_beli*1 * (item.penerimaan_detail_ppn_beli*1/100))
              item.sub_total = item.penerimaan_detail_qty*(item.penerimaan_detail_harga_beli*1 + (item.penerimaan_detail_harga_beli*1 * (item.penerimaan_detail_ppn_beli*1/100)))
            })
            this.form.varian_arr.map((item, index) => {
              this.total_nominal += item.sub_total
            })
            }
            this.process.load = false
          })
        },
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.rejected_reason = ''
  
          this.process.form = false
  
          this.message.error = ''
        },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
  
        async save () {
          this.message.error = ''
          const isValid = await this.$refs.form.validate(),
          imgValid = true
          if (this.form.payment_bukti_url === '' || this.form.payment_bukti_url === null) {
            this.message.error = 'Bukti Pembayaran harus diisi'
            imgValid = false
          }
          // console.log(isValid, imgValid)
          if (isValid && imgValid) {
            
  
          this.process.form = true
          let form = {
            faktur_id: this.detail.id,
            payment_method: this.form.payment_method,
            payment_bank_name: this.form.payment_method === 'Tunai' ? '' : this.form.payment_bank_name,
            payment_rek_number: this.form.payment_method === 'Tunai' ? '' : this.form.payment_rek_number,
            payment_bukti_url: this.form.payment_bukti_url
          }
  
          let url = 'admin/invoice/payment'
  
          await post(url, {
            data: form
          }).then(response => {
            let res = response.data
  
            this.process.form = false
  
            if (res.status === 200) {
  
              this.dialog.pembayaran = false
  
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
  
          
        }
      }
    }
  </script>

<style>
table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }
</style>